const actionsRegExps = [
    /UPDATE_OPPORTUNITY\s*([A-z]*)/,
    /UPDATE_CUSTOMER/,
];

const removeActionsTokens = (message: string = '') => actionsRegExps.reduce((acc, regex) => acc.replace(regex, ''), message);

export default removeActionsTokens;
